import { useState } from "react";
import { useNavigate } from "react-router";
import { signIn } from "@/lib/api";
import { Button, ErrorText, Field, Input } from "@/ui/kit";
import { Logo } from "@/ui/Logo";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);

  return (
    <div className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center px-5 py-10">
      <Logo className="mb-6 h-16 w-auto self-start" />
      <h1 className="text-3xl font-bold tracking-tight">Admin sign in</h1>
      <p className="mb-6 text-muted">Modern Motherhood community tools.</p>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          try {
            await signIn(email.trim(), password, totp.trim());
            nav("/", { replace: true });
          } catch (err) {
            setError(err);
            setTotp("");
          } finally {
            setBusy(false);
          }
        }}
      >
        <Field label="Email">{(id) => <Input id={id} type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />}</Field>
        <Field label="Password">{(id) => <Input id={id} type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />}</Field>
        <Field label="6-digit code" hint="From your authenticator app.">
          {(id) => (
            <Input id={id} inputMode="numeric" autoComplete="one-time-code" pattern="\d{6}" maxLength={6} value={totp} onChange={(e) => setTotp(e.target.value.replace(/\D/g, ""))} required className="tracking-[0.4em] text-lg" />
          )}
        </Field>
        <ErrorText error={error} />
        <Button type="submit" className="mt-2 w-full" loading={busy}>
          Sign in
        </Button>
      </form>
    </div>
  );
}
